<div *ngIf="companyOrderTypeWorkForm" class="form-modal">
  <h1 mat-dialog-title>{{'ASSOCIATION' | translate}}</h1>
  <div mat-dialog-content>
    <form [formGroup]="companyOrderTypeWorkForm" class="form-horizontal">
      <div class="form-group">
        <div class="col-md-12 col-xs-12">
          <mat-form-field class="full-width">
            <mat-select placeholder="Documento" formControlName="TypeID">
              <mat-option *ngFor="let item of orderTypes" [value]="item.ID">{{item.Name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-12 col-sm-12 spacer-bottom-xs"></div>
        <div class="col-md-12 col-xs-12">
          <mat-form-field class="full-width">
            <mat-select placeholder="Workflow" formControlName="WorkflowID">
              <mat-option *ngFor="let item of ordersWorkflowList" [value]="item.ID">{{item.Name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-12 col-sm-12 spacer-bottom-xs"></div>
      </div>
    </form>
  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right">
      <button type="button" class="btn btn-default" (click)="resetForm();dialogRef.close(null)">
        <i class="fas fa-ban"></i>&nbsp;{{'BUTTON.CANCEL' | translate}}
      </button>
      <button type="button" class="btn btn-primary" (click)="save()" [disabled]="!companyOrderTypeWorkForm.valid">
        <i class="far fa-save"></i>&nbsp;{{'BUTTON.SAVE' | translate}}
      </button>
    </div>
  </div>
</div>